<div class="relative">
    <esk-select
          [options]="selectModel()"
          placeholder="Select a Property"
          class="w-full"
          [ngModel]="selectedProperty()"
          (ngModelChange)="setActiveProperty($event)"
        >
          <ng-template #selectedOption let-option let-index="index">
            <div class="flex items-center justify-center flex-grow gap-3 px-1 text-black">
              <span class="text-sm">{{option?.displayName ?? ""}}</span>
            </div>
          </ng-template>

          <ng-template #option let-option let-index="index">
            <div class="flex items-center gap-3 px-1">
             <span class="text-sm">{{option.displayName}}</span>
            </div>
          </ng-template>
        </esk-select>
</div>
